import React from 'react'
import { Container, Row, Col } from "react-bootstrap";

export default function StaggerSection() {

    return (
        <section className='padding-section-large bg-gradient-1'>
            <Container>
                <Row className=''>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">What We <span className="text-gradient-1">Stand By</span></h2>
                        <h5 className='heading-style-h5 pb-5'>Simple principles that guide how we think, build and deliver, every single day. </h5>
                    </Col>
                </Row>
                <Row className="d-flex align-items-stretch stagger-wrapper">
                    <div className="stagger-grid">
                        {/* Card 1 */}
                        <div className="card-box primary-border light-bg logo-bg">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Built Around Real System Behavior</h5>
                            <p>We focus on how systems behave  over time, not just how they are delivered </p>
                        </div>

                        {/* Card 2 */}
                        <div className="card-box card-moveBottom">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Balanced Across Development, QA and Operations </h5>
                            <p>A combined approach that keeps things stable and consistent at every stage </p>
                        </div>

                        {/* Card 3 */}
                        <div className="card-box card-2">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Structured, Not Reactive </h5>
                            <p>Clear processes reduce uncertainty and help keep delivery predictable </p>
                        </div>

                        {/* Card 4 */}
                        <div className="card-box card-moveBottom">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Aligned with Your Way of Working </h5>
                            <p>We adapt to your workflows rather than forcing new ones </p>
                        </div>

                        {/* Card 5 */}
                        <div className="card-box card-4">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Focused on Long-Term Performance </h5>
                            <p>Success is measured by how systems hold up after delivery, not just at launch </p>
                        </div>
                    </div>
                </Row>

                <Row>
                    <div className='bg-gradient-2 text-white p-4 mx-auto text-center w-auto'>
                        <p className='mb-0'>It’s a simple approach, but one that holds up when things get complex.</p>
                    </div>
                </Row>
            </Container>
        </section>
    );
}
